// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__yfmPA","amount":"Amount_amount__3wUph","tip":"Amount_tip__3cCf1","tipHeader":"Amount_tipHeader__3e2IR","tipsWrap":"Amount_tipsWrap__3U3ZK"};